import { faCoins } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import type React from 'react'
import { useState } from 'react'

interface AssetIconProps {
  iconUrl?: string | null
  alt?: string
  className?: string
}

// A crypto asset's coin logo (served from its Currency's iconUrl), falling back to a generic coin glyph
// when there's no URL or the image fails to load — so a missing/404 logo never leaves a broken image on
// the wall board.
const AssetIcon: React.FC<AssetIconProps> = ({
  iconUrl,
  alt = '',
  className = '',
}) => {
  const [failed, setFailed] = useState(false)

  if (!iconUrl || failed) {
    return <FontAwesomeIcon icon={faCoins} className={`text-amber-300/80 ${className}`} />
  }

  return (
    <img
      src={iconUrl}
      alt={alt}
      className={`rounded-full object-contain ${className}`}
      onError={() => setFailed(true)}
    />
  )
}

export default AssetIcon
